import { useEffect, useState } from 'react';
import { useNFTS } from '../../hooks/useNFTS';
import { ethers } from 'ethers';
import config from '../../config';
import { CircularProgress } from '@mui/material';
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { setToast } from '../../store/actions/Toast';
import { CountDown } from '../atoms';


const TimerCard = (props: any) => {
  const [time, setTime] = useState<any>(0);
  const [isFinished, setIsFinished] = useState(false);


  const myNFTs = useNFTS();
  const dispatch: Dispatch<any> = useDispatch();

  const init = async () => {
    if (myNFTs.nfts.supplyData) {
      setTime(myNFTs.nfts.supplyData.endTime * 1000)
    }
  }

  useEffect(() => {
    init()
  }, [myNFTs]);

  return (
    <div className="timer-card">
      <div className="card-header">
        <h1>Yield ends in</h1>
      </div>
      <div className='timer-body'>
        <CountDown
          targetDate={time}
          setCountDownEnded={setIsFinished}
        />
      </div>

    </div>
  );
};

export default TimerCard;
